import React from 'react'; import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'; import { faShieldAlt, faHandHoldingUsd, faHouseChimney } from '@fortawesome/free-solid-svg-icons'; import './service1.css';

const ServiceV3 = () => {
  return (
    <div className="service-section" style={{ padding: '60px 0', textAlign: 'center' }}>
      <div className="container">
        <div className="row justify-content-center">
          {/* Services en colonnes */}
          <div className="col-lg-4 col-md-6 d-flex align-items-stretch">
            <div className="service-box mx-auto d-flex flex-column" style={{ maxWidth: '400px', flex: '1' }}>
              <FontAwesomeIcon icon={faShieldAlt} className="service-icon" />
              <h4>🛡️ Conformité légale</h4>
              <p>
                Optez pour une procédure de vérification stricte des documents d’identité et des justificatifs
                pour garantir l’authenticité de chaque dossier. Cette démarche rigoureuse vise à prévenir
                les risques de fraude et à assurer des transactions sécurisées pour la vente et la location
                sur notre plateforme.
              </p>
            </div>
          </div>

          <div className="col-lg-4 col-md-6 d-flex align-items-stretch">
            <div className="service-box mx-auto d-flex flex-column" style={{ maxWidth: '400px', flex: '1' }}>
              <FontAwesomeIcon icon={faHandHoldingUsd} className="service-icon" />
              <h4>💰 Financement facile</h4>
              <p>
                Profitez de la puissance de notre réseau pour obtenir les meilleurs taux et conditions du marché,
                adaptés à votre profil, sans avoir à négocier. Nos spécialistes recherchent pour vous les offres
                les plus avantageuses, vous permettant d’accéder à des dizaines d’options en une seule rencontre.
              </p>
            </div>
          </div>

          <div className="col-lg-4 col-md-6 d-flex align-items-stretch">
            <div className="service-box mx-auto d-flex flex-column" style={{ maxWidth: '400px', flex: '1' }}>
              <FontAwesomeIcon icon={faHouseChimney} className="service-icon" />
              <h4>🏠 Assurance habitation</h4>
              <p>
                Optez pour une assurance habitation adaptée à votre maison, appartement ou logement et bénéficiez
                d'une couverture optimale pour protéger votre résidence et vos biens en cas de sinistre.
                Explorez les garanties, profitez de nos réductions négociées auprès de nos partenaires et obtenez
                l'offre qui vous correspond.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceV3;
